
import './style.scss';
import { Typography } from "@mui/material";
import { useLanguageContext } from "../../contexts/LanguageContext";
import { RegistrationStatusEnum, RegistrationStatusData } from '../../data/Enums';


interface IRegistrationStatusProps {
    id: RegistrationStatusEnum;
    size?: 'sm' | 'md' | 'lg';
}


const RegistrationStatus: React.FunctionComponent<IRegistrationStatusProps> = ({
    id,
    size = 'md'
}) => {
    const { translate } = useLanguageContext();
    const registrationStatus = RegistrationStatusData[id in RegistrationStatusEnum ? id : RegistrationStatusEnum.Empty];

    return (
        <Typography
            variant='subtitle2'
            className={`text-registrationstatus ${registrationStatus.className} size-${size}`}
        >
            <registrationStatus.Icon />
            {translate(registrationStatus.name) || ''}
        </Typography>
    );
}

export default RegistrationStatus;